import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';

const ChatImagePreview = ({ src, alt = 'Image preview', onClose }) => {
  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevPosition = document.body.style.position;
    const prevWidth = document.body.style.width;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.position = prevPosition;
      document.body.style.width = prevWidth;
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handleClose]);

  if (!src || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className="cm_chat_media_fullscreen"
      onClick={handleClose}
      role="dialog"
      aria-modal="true"
      aria-label="Image preview"
    >
      <div className="cm_chat_media_fullscreen_backdrop" aria-hidden />
      <span
        role="button"
        tabIndex={0}
        className="cm_modal_close_btn cm_chat_media_fullscreen_close"
        onClick={(event) => {
          event.stopPropagation();
          handleClose();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClose();
          }
        }}
        aria-label="Close image preview"
      >
        <i className="fa fa-xmark" aria-hidden />
      </span>
      <img
        src={src}
        alt={alt}
        className="cm_chat_media_fullscreen_img"
        onClick={(event) => event.stopPropagation()}
        draggable={false}
      />
    </div>,
    document.body
  );
};

export default ChatImagePreview;
